<template>
	<div v-if="type === 'phone'" @click="copyPhone" class="u-cursor-pointer">
		<slot></slot>
	</div>

	<a target="_self" v-else-if="type === 'link'" class="text-decoration-none u-cursor-pointer">
		<slot></slot>
	</a>
	<a target="_self" v-else-if="type === 'map'" class="text-decoration-none u-cursor-pointer">
		<slot></slot>
	</a>

	<a v-else-if="type === 'email'" :href="'mailto:' + value" class="text-decoration-none u-cursor-pointer">
		<slot></slot>
	</a>

	<div
		v-else-if="type === 'fileList'"
		@click="navigateToAction"
		class="text-decoration-none u-cursor-pointer text--black"
	>
		<slot></slot>
	</div>

	<div
		v-else-if="type === 'linkList'"
		@click="navigateToLink"
		class="text-decoration-none u-cursor-pointer text--black"
	>
		<slot></slot>
	</div>
	<a v-else-if="type === 'deepLink'" target="_self" class="u-cursor-pointer text-decoration-none">
		<slot></slot>
	</a>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import { mapActions, mapGetters } from 'vuex'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
Vue.use(VueScrollTo)

export default {
	name: 'ActionPreview',

	props: {
		action: {
			type: Object,
			default: () => ({}),
		},
		eventId: { type: [String, Number], default: null },
	},

	data() {
		return {
			successMessage: '',
		}
	},

	computed: {
		...mapGetters('app', ['isShowAlert', 'alertMessage']),
		type() {
			const { action_type: type } = this.action || {}
			return String(type)
		},
		value() {
			const { action_value: value } = this.action || {}
			return value
		},
		actionId() {
			const { action_id: value } = this.action || {}
			return value
		},
	},
	methods: {
		...mapActions('app', ['showAlert', 'hideAlert']),
		navigateToAction() {
			if (this.$route.name === 'event-by-id') {
				this.$router.push({
					name: 'event-actions-by-id',
					params: {
						eventId: this.eventId,
						actionId: this.actionId,
					},
					query: {
						title: this.action.action_name,
						source: 'event',
					},
				})
			}
			if (this.$route.name === 'event-session-by-id') {
				this.$router.push({
					name: 'event-actions-by-id',
					params: {
						eventId: this.eventId,
						actionId: this.actionId,
					},
					query: {
						title: this.action.action_name,
						source: 'session',
					},
				})
			}
		},
		navigateToLink() {
			if (this.$route.name === 'event-by-id') {
				this.$router.push({
					name: 'event-links-by-id',
					params: {
						eventId: this.eventId,
						actionId: this.actionId,
					},
					query: {
						title: this.action.action_name,
						source: 'event',
					},
				})
			}
			if (this.$route.name === 'event-session-by-id') {
				this.$router.push({
					name: 'event-links-by-id',
					params: {
						eventId: this.eventId,
						actionId: this.actionId,
					},
					query: {
						title: this.action.action_name,
						source: 'session',
					},
				})
			}
		},

		copyPhone() {
			if (!this.isShowAlert) {
				const phone = this.value.replace(/\D/g, '')

				this.$copyText(phone).then(() => {
					const closeTimeout = setTimeout(() => {
						this.hideAlert('')
					}, 3000)

					this.showAlert({ message: 'Phone number copied successfully.', closeTimeout })
				})
			}
		},
	},
}
</script>

<style lang="scss"></style>
